// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
    /* display: flex;
    flex-direction: column;
    gap: 1rem; */
}

.form-input {
    /* width: 100%;
    padding: 0.5rem;
    font-size: 1rem; */
}

.form-button {
    /* padding: 0.5rem;
    font-size: 1rem;
    cursor: pointer; */
}

.panel-tabs {
    font-size: 20px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Form.css"],"names":[],"mappings":"AAAA;IACI;;gBAEY;AAChB;;AAEA;IACI;;sBAEkB;AACtB;;AAEA;IACI;;sBAEkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".form-container {\n    /* display: flex;\n    flex-direction: column;\n    gap: 1rem; */\n}\n\n.form-input {\n    /* width: 100%;\n    padding: 0.5rem;\n    font-size: 1rem; */\n}\n\n.form-button {\n    /* padding: 0.5rem;\n    font-size: 1rem;\n    cursor: pointer; */\n}\n\n.panel-tabs {\n    font-size: 20px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
